<template>
	<BuyersOrderGroup name="Finance Charge Fees">
		<template #right-icon>
			<span>+</span>
		</template>

		<template #column-1>
			<InputCurrency
				:saturn="feeAmountTotal"
				:disabled="true"
				:precision="2"
				iconSide="left"
				:negative="true"
			/>
		</template>

		<template #column-2>
			<InputCurrency
				:saturn="feeCostTotal"
				:disabled="true"
				:precision="2"
				iconSide="left"
				:negative="true"
			/>
		</template>

		<template #children>
			<BuyersOrderRow
				v-for="fee in financeChargeFees"
				:key="fee.name"
			>
				<template #info>
					<a
						class="bucket-item-name clickable"
						@click="() => addEditItem(fee)"
					>
						<span>{{ fee.name.toUpperCase() }}</span>
						<div class="bucket-item-subname">
							{{ feeSourceEnumsHelper.getDisplay(fee.source) }}
						</div>
					</a>
				</template>

				<template #right-icon>
					<span>+</span>
				</template>

				<template #column-1>
					<InputCurrency
						:saturn="fee.amount"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					>
					</InputCurrency>
				</template>

				<template #column-2>
					<InputCurrency
						:saturn="fee.cost"
						:disabled="true"
						:precision="2"
						iconSide="left"
						:negative="true"
					>
					</InputCurrency>
				</template>
			</BuyersOrderRow>
		</template>
	</BuyersOrderGroup>
</template>

<script lang="ts">
	export interface IBuyersOrderFinanceChargeFeesProps {
		financeChargeFees: FIMenuBuyersOrderFee[];
		addEditItem: (fee: FIMenuBuyersOrderFee) => void;
	}
</script>

<script setup lang="ts">
	import BuyersOrderGroup from '@/components/buyers-order/BuyersOrderGroup.vue';
	import BuyersOrderRow from '@/components/buyers-order/BuyersOrderRow.vue';
	import { computed } from 'vue';
	import FeeSourceEnumsHelper from '@core/_enums/FeeSourceEnumsHelper';
	import FIMenuBuyersOrderFee from '@core/classes/FIMenuBuyersOrderFee';
	import InputCurrency from '@core/components/InputCurrency.vue';

	const { financeChargeFees, addEditItem } = defineProps<IBuyersOrderFinanceChargeFeesProps>();

	const feeSourceEnumsHelper = new FeeSourceEnumsHelper();

	const feeAmountTotal = computed(() => financeChargeFees.reduce((total, fee) => total + fee.amount, 0));
	const feeCostTotal = computed(() => financeChargeFees.reduce((total, fee) => total + fee.cost, 0));
</script>

<style scoped>
	.bucket-item-name span {
		text-decoration: underline;
	}
</style>
